export const DEPENDENCY_KEYS = {
    // Aux
    CLIENT_BASE_URL: 'CLIENT_BASE_URL',
    WEB_SERVICE_ENDPOINT: 'WEB_SERVICE_ENDPOINT',
    DEFAULT_ROUTE: 'DEFAULT_ROUTE',
    // Components
    BillingMenuItem: 'BillingMenuItem',
    BillingPlansLink: 'BillingPlansLink',
    DiagnosticReportFlow: 'DiagnosticReportFlow',
    DirectLink: 'DirectLink',
    DownloadDesktopAppLink: 'DownloadDesktopAppLink',
    ExitAppFlow: 'ExitAppFlow',
    FilespaceCard: 'FilespaceCard',
    FilespaceDashboard: 'FilespaceDashboard',
    FilespaceSettings: 'FilespaceSettings',
    FilespaceMigration: 'FilespaceMigration',
    FilespaceFooter: 'FilespaceFooter',
    FilespaceListItem: 'FilespaceListItem',
    LogoutFlow: 'LogoutFlow',
    LucidlinkClassicLink: 'LucidlinkClassicLink',
    NoWorkspacesFsMigrateLink: 'NoWorkspacesFsMigrateLink',
    NoWorkspacesChannelPartnerMigrateLink: 'NoWorkspacesChannelPartnerMigrateLink',
    PinningFlow: 'PinningFlow',
    SupportMenu: 'SupportMenu',
    UploadYourFirstFilesAction: 'UploadYourFirstFilesAction',
    UserMenuExitAppOption: 'UserMenuExitAppOption',
    UserMenuGoToManagementPlatformOption: 'UserMenuGoToManagementPlatformOption',
    UserMenuMigrateChannelPartnerFilespaceOption: 'UserMenuMigrateChannelPartnerFilespaceOption',
    UserMenuMigrateFilespaceOption: 'UserMenuMigrateFilespaceOption',
    WorkspaceLimitNavToBilling: 'WorkspaceLimitNavToBilling',
    WorkspaceSettingsSidebarBillingMenuItem: 'WorkspaceSettingsSidebarBillingMenuItem',
    WorkspaceSSOAuthentication: 'WorkspaceSSOAuthentication',
    WorkspaceSuspendedNavToBilling: 'WorkspaceSuspendedNavToBilling',
    // Hooks
    UseFilespaceOpenInFileExplorer: 'useFilespaceOpenInFileExplorer',
    UseFilespaceQuit: 'useFilespaceQuit',
    UseFilespaceSnapshots: 'useFilespaceSnapshots',
    UseGuestLinkGoToFolder: 'useGuestLinkGoToFolder',
    UseNotificationMessages: 'useNotificationMessages',
    UseOnCurrentUserChange: 'useOnCurrentUserChange',
    UseReconnectFilespaces: 'useReconnectFilespaces',
    UseFilespacesDisconnectOnNoAccess: 'useFilespacesDisconnectOnNoAccess',
    UseFilespaceUpgradeNotifier: 'useFilespaceUpgradeNotifier',
    //Login hooks
    UseLoginEmail: 'useLoginEmail',
    UseLoginPassword: 'useLoginPassword',
    UseLoginSsoKey: 'useLoginSsoKey',
    UseLoginWorkspaceName: 'useLoginWorkspaceName',
    UseStartSsoAuthentication: 'useStartSsoAuthentication',
    // Filespace Settings
    FilespaceReconnect: 'FilespaceReconnect',
    // UI Hooks
    UseFilespaceSettingsToasts: 'useFilespaceSettingsToasts',
    UseHandleMissingCacheLocation: 'useHandleMissingCacheLocation',
    UseOnMountPointReset: 'UseOnMountPointReset',
    // Global
    UseGetGlobalSettings: 'useGetGlobalSettings',
    UseSetGlobalSettings: 'useSetGlobalSettings',
    UseSetGlobalTeamCache: 'useSetGlobalTeamCache',
    UseUnsetGlobalSettings: 'useUnsetGlobalSettings',
    // FilespaceSettings
    // Functions
    RestrictedFilespacePredicate: 'restrictedFilespacePredicate',
    GetAdditionalInfo: 'getAdditionalInfo',
    // Plain texts
    ServiceUnavailableViewMessage: 'serviceUnavailableViewMessage',
};
export const NOTIFICATION_MESSAGE_TYPES = {
    AppQuitRequested: 'appQuitRequested',
    OpenFilespaceRequested: 'openFilespaceRequested',
    OpenFilespaceSnapshots: 'openFilespaceSnapshots',
    OpenFilespaceLocalSettings: 'openFilespaceLocalSettings',
    OpenFilespaceUpgrade: 'openFilespaceUpgrade',
    CreateGuestLink: 'createGuestLink',
    PinEntriesRequested: 'pinEntriesRequested',
    PublishRequested: 'publishRequested',
    DirectLink: 'directLink',
    SsoLogin: 'ssoLogin',
    WindowCloseRequested: 'windowCloseRequested',
};
export const LUCIDLINK_CLASSIC_LINK_LOCATIONS = {
    LOGIN: 'login',
    REGISTER: 'register',
};
